var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel-header',{staticClass:"white--text elevation-5 rounded-0 no-shadow-below",attrs:{"color":"primary"},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-icon',{attrs:{"color":"white"}},[_vm._v(" $expand ")])]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }